import { render, staticRenderFns } from "./funBox.vue?vue&type=template&id=6125cb4e&scoped=true"
import script from "./funBox.vue?vue&type=script&lang=js"
export * from "./funBox.vue?vue&type=script&lang=js"
import style0 from "./funBox.vue?vue&type=style&index=0&id=6125cb4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125cb4e",
  null
  
)

export default component.exports